import { NavLink, Link } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { useState } from "react";
import { BRAND } from "@/content";
import { LogoMark } from "@/components/Logo";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/diagnostic", label: "Diagnostic" },
  { to: "/dashboard", label: "Dashboard" },
  { to: "/case-studies", label: "Case Studies" },
  { to: "/insights", label: "Insights" },
  { to: "/about", label: "About" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-40 border-b border-slate-200/70 bg-white/85 backdrop-blur-xl"
    >
      <div className="mx-auto max-w-[1440px] px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid="brand-logo"
          className="flex items-center gap-2.5 group"
        >
          <LogoMark size={30} />
          <span className="text-[17px] font-semibold tracking-tight text-slate-900">
            {BRAND.name}
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              data-testid={`nav-link-${n.label.toLowerCase().replace(/\s+/g, '-')}`}
              className={({ isActive }) =>
                `text-[13.5px] tracking-[0.01em] font-medium transition-colors ${
                  isActive
                    ? "text-slate-900"
                    : "text-slate-500 hover:text-slate-900"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/contact"
            data-testid="nav-cta-contact"
            className="hidden sm:inline-flex items-center gap-1.5 rounded-full bg-slate-900 text-white text-[13px] font-medium px-4 py-2 hover:bg-black transition-colors"
          >
            Book a working session
            <ArrowUpRight className="h-3.5 w-3.5" />
          </Link>
          <button
            className="lg:hidden inline-flex items-center justify-center h-10 w-10 rounded-md border border-slate-200"
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
          >
            {open ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-white">
          <div className="px-6 py-4 flex flex-col gap-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${n.label.toLowerCase().replace(/\s+/g, '-')}`}
                className={({ isActive }) =>
                  `py-2 text-sm font-medium ${
                    isActive ? "text-slate-900" : "text-slate-500"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              data-testid="mobile-nav-cta"
              className="mt-3 inline-flex items-center justify-center gap-1.5 rounded-full bg-slate-900 text-white text-sm font-medium px-4 py-2"
            >
              Book a working session
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
